export const SENTIMENT_COLORS = {
  strongly_supportive: "#059669",
  supportive_conditional: "#10B981",
  supportive_but_constrained: "#D97706",
  constrained: "#DC2626",
  resistant: "#7F1D1D",
  unknown: "#64748B",
};

export const SENTIMENT_LABELS = {
  strongly_supportive: "Strongly supportive",
  supportive_conditional: "Supportive, conditional",
  supportive_but_constrained: "Supportive, constrained by context",
  constrained: "Constrained",
  resistant: "Resistant",
  unknown: "Not classified",
};

export const SENTIMENT_ORDER = [
  "strongly_supportive",
  "supportive_conditional",
  "supportive_but_constrained",
  "constrained",
  "resistant",
];

export const CONSTRAINT_LABELS = {
  visual_impact: "Visual impact",
  planning_sdnp: "Planning / SDNP",
  wildlife_ecology: "Wildlife / ecology",
  noise: "Noise",
  proximity_to_homes: "Proximity to homes",
  practicality_wind_resource: "Practicality / wind resource",
  grid_infrastructure: "Grid / infrastructure",
  other: "Other",
};

export const SITING_LABELS = {
  high_ground: "High ground",
  infrastructure_corridors: "Infrastructure corridors",
  existing_energy_infrastructure: "Existing energy infrastructure",
  industrial_port_areas: "Industrial / port areas",
  avoid_key_viewpoints: "Avoid key viewpoints",
};

export function sentimentBadgeClasses(sentiment) {
  switch (sentiment) {
    case "strongly_supportive":
      return "bg-emerald-50 text-emerald-800 border border-emerald-200";
    case "supportive_conditional":
      return "bg-emerald-50 text-emerald-700 border border-emerald-200";
    case "supportive_but_constrained":
      return "bg-amber-50 text-amber-800 border border-amber-200";
    case "constrained":
      return "bg-rose-50 text-rose-800 border border-rose-200";
    case "resistant":
      return "bg-red-100 text-red-900 border border-red-300";
    default:
      return "bg-slate-50 text-slate-700 border border-slate-200";
  }
}

export function yesNo(v) {
  if (v === true) return "Yes";
  if (v === false) return "No";
  return "—";
}

export function formatList(arr, labels) {
  if (!arr || arr.length === 0) return "—";
  return arr.map((k) => (labels && labels[k]) || k).join(", ");
}

export function truncate(str, n = 120) {
  if (!str) return "";
  return str.length > n ? str.slice(0, n - 1) + "…" : str;
}

/**
 * Turn a workshop's dual signal (explicit / implicit) into a human label:
 *   "Yes · explicit"
 *   "Yes · from design"
 *   "No"
 */
export function dualSignalLabel(explicit, implicit) {
  if (explicit) return "Yes · explicit";
  if (implicit) return "Yes · from design";
  return "No";
}
